import { FusionColor } from "../../../theme/FusionStyle"
import { V2L1ReasonableButton } from "../Button/V2L1ReasonableButton"
import { V2L1AppHeaderSpacer } from "./V2L1AppHeaderComponents"
import { faReply } from '@fortawesome/pro-regular-svg-icons'

interface V2L3FormAppHeaderContentProps {
	onExitClick?: () => void
}

export const V2L3FormPrintAppHeaderContent = ({onExitClick}: V2L3FormAppHeaderContentProps) => {
	return (
		<>
			<V2L1AppHeaderSpacer />
			<V2L1ReasonableButton
				icon={faReply}
				label="Exit Print Mode"
				color={FusionColor.White}
				onClick={onExitClick}
			/>
		</>
	)
}


